import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function UnaffectedBreastCancerExclusively() {
    return ReferralCriteria({
        statement: (
            <p>
                These patients should be referred to your local family history clinic (unless there is a known mutation
                in the family).  A risk assessment will be undertaken in the family history clinic and those individuals
                whose family is elligible for genetic testing or risk reducing surgery will be referred into the
                regional genetics service.
            </p>
        ),
        properties: {
            color: 'pink'
        }
    });
}

export default UnaffectedBreastCancerExclusively;
